define('modules/accounts/status/index',['require','exports','module','./view','./view-no-service','./products/mdirector/view','./products/mdirector/model','./products/landings/view','./products/landings/model'],function(require, exports, module) {
    "use strict";

    var MainView = require("./view");
    var NoServiceView = require("./view-no-service");

    var Products = {
        mdirector: {
            View: require("./products/mdirector/view"),
            Model: require("./products/mdirector/model")

        },
        landings: {
            View: require("./products/landings/view"),
            Model: require("./products/landings/model")
        }
    };
    var currentModel;

    var init = function(el, me, group, service) {
        var statusMainView, statusProductView, statusProductModel;
        service = (service) ? service.toLowerCase() : "mdirector";

        statusMainView = new MainView({
            el: el,
            activeTab: service,
            model: group
        });
        statusMainView.render();
        if (group.hasService(service)) {
            statusProductModel = new Products[service].Model();
            statusProductView = new Products[service].View({
                el: "#status-tab-content",
                group: group,
                model: statusProductModel
            });
            statusProductModel.set('groupId',group.id);
            statusProductModel.fetch();
            currentModel = statusProductModel;
        } else {
            new NoServiceView({
                el: "#status-tab-content",
                service: service
            }).render();
        }
    };

    module.exports = {
        init: init,
        Products: Products,
        // make this module testeable
        getCurrentModel: function() {
            return currentModel;
        }
    };

});

